module.exports = __webpack_public_path__ + "media/images/views/home/benefit/benefit-2-94ff86448f550b1490422d2b5185dc4a.png";